import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { FeaturesPage } from './pages/FeaturesPage';
import { PricingPage } from './pages/PricingPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { TrustCenterPage } from './pages/TrustCenterPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { EULAPage } from './pages/EULAPage';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/features" element={<FeaturesPage data-id="element-6" />} data-id="element-5" />
          <Route path="/pricing" element={<PricingPage data-id="element-8" />} data-id="element-7" />
          <Route path="/resources" element={<ResourcesPage data-id="element-10" />} data-id="element-9" />
          <Route path="/trust" element={<TrustCenterPage data-id="element-12" />} data-id="element-11" />
          <Route path="/about" element={<AboutPage data-id="element-14" />} data-id="element-13" />
          <Route path="/contact" element={<ContactPage data-id="element-16" />} data-id="element-15" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-18" />} data-id="element-17" />
          <Route path="/terms" element={<TermsPage data-id="element-20" />} data-id="element-19" />
          <Route path="/eula" element={<EULAPage data-id="element-22" />} data-id="element-21" />
        </Routes>
      </Layout>
    </Router>;
}